'use client';

export { default } from './TableHead';
export { default as tableHeadClasses } from './tableHeadClasses';
export * from './tableHeadClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableHead/index.js
// module id = 895
// module chunks = 22